import { render } from "./ShowService.vue?vue&type=template&id=84c47592"
import script from "./ShowService.vue?vue&type=script&lang=js"
export * from "./ShowService.vue?vue&type=script&lang=js"

import "./ShowService.vue?vue&type=style&index=0&id=84c47592&lang=scss"

import exportComponent from "/home/ubuntu/jalizan/webapp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__